// extracted by mini-css-extract-plugin
module.exports = {"photo-priority":"photo-priority-multi-author-m__photo-priority__DusIm"};